import { render, staticRenderFns } from "./DiscountsHandler.vue?vue&type=template&id=41b97c68&scoped=true&"
import script from "./DiscountsHandler.vue?vue&type=script&lang=js&"
export * from "./DiscountsHandler.vue?vue&type=script&lang=js&"
import style0 from "./DiscountsHandler.vue?vue&type=style&index=0&id=41b97c68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b97c68",
  null
  
)

export default component.exports